module.exports = __webpack_public_path__ + "media/img/feature-icon-export-a4db9e82e0eecc387ce49de69b39c4d3.svg";